import { useQuery } from "@tanstack/react-query";
import api from "../../../../../utils/api";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { useParams } from "react-router-dom";

export type TLider = {
  cargo: string;
  celula: number;
  cpf: string;
  grupo: null;
  id: number;
  ministerio: null;
  ministerio_celula: number;
  nome_cargo: string;
  nome_celula: string;
  nome_grupo: null;
  nome_ministerio: null;
  nome_ministerio_celula: string;
  nome_sede: null;
  nome_sede_celula: string;
  nome_usuario: string;
  sede: null;
  sede_celula: number;
  telefone: string;
  usuario: number;
};

const ServicesLideres = () => {

  const {id: idCelula} = useParams();

  const { setErrorSuccess } = useErrorSuccess();

  const { data: lideres = [], refetch } = useQuery({
    queryFn: () => api.get<TLider[]>("view/cargo/pg/"+idCelula),
    queryKey: ['coordenadores-lista'],
    select: (data) => data?.data
   });



  const removeLideres = async (lider: TLider) => {
    try {
      const req = await api.delete('ministerio/cargo/usuario/apagar/geral/'+lider?.usuario+'/'+lider?.celula);
      const res = req.data;

      setErrorSuccess({
        mensagem: 'Removido!',
        status: 'success'
      })


      await refetch();

    } catch (error) {
      setErrorSuccess({
        mensagem: JSON.stringify(error?.response?.data, null, 2),
        status: 'error'
      })
    }
  }



  return {
    lideres,
    removeLideres
  };
};

export default ServicesLideres;
